<template>
  <svg viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <ellipse fill="none" stroke="currentColor" stroke-width="1" cx="256" cy="256" :rx="rX" ry="256" vector-effect="non-scaling-stroke"></ellipse>
  </svg>
</template>

<script>
export default {
  name: 'AudioArc',
  props: ['dX'],
  computed: {
    ready () {
      return !isNaN(this.dX)
    },
    rX () {
      const x = Math.abs(this.dX) > 0.498 ? 0.5 : Math.abs(this.dX)
      return 256 * x * 2
    }
  }
}
</script>
